import { styled, alpha } from "@mui/material/styles";
import { Grid, Button as MuiButton } from "@mui/material";
import styledComponent from "styled-components";

// export const Button = styled(MuiButton)(({ theme }) => ({
//   minWidth: "40px",

//   svg: {
//     color: theme.palette.primary.contrastText,
//   },

//   "&:hover": {
//     backgroundColor: "rgba(255, 255, 255, .5)",
//   },
// }));

export const Button = styled(MuiButton, {
  shouldForwardProp: (props) => props !== "filterColor",
})<{ filterColor?: string }>(({ filterColor, theme }) => ({
  minWidth: "40px",

  svg: {
    color: filterColor !== "filter" ? theme.palette.primary.contrastText : theme.palette.primary.main,
  },

  "&:hover": {
    backgroundColor:
      filterColor !== "filter" ? alpha(theme.palette.background.default, 0.5) : theme.palette.secondary.main,
  },
}));

export const Container = styled(Grid)({
  display: "flex",
  alignItems: "center",
});

export const DatePickerWrapper = styledComponent(Grid)`
  .react-datepicker-popper {
    z-index: 9999 !important;
  }
`;
